import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Cliques por botão',
  action: 'Botão',
  clicks: 'Cliques',
  people: 'Pessoas',
  hidden: '— menos de 20 pessoas',
  empty: 'Nenhum clique nos botões no período.',
} satisfies TranslationTree;
